/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ slug: NonNullable<unknown> }} Error_Shop_Target_Group_MissingInputs */

const vi_error_shop_target_group_missing = /** @type {(inputs: Error_Shop_Target_Group_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nhóm sản phẩm "${i?.slug}" không còn tồn tại — chọn nhóm khác cho liên kết.`)
};

/**

* @param {Error_Shop_Target_Group_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_target_group_missing = /** @type {((inputs: Error_Shop_Target_Group_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Target_Group_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_target_group_missing(inputs)
});